import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'components/form/Button';
import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import DeletePopup from 'components/Layout/DeletePopup';
import ServicesDataForm from './ServicesDataForm';
import { deleteOnServicesData, fetchAddOnServicesData } from 'store/slices';
import { icons } from 'utils/constants';
import { objectToFormData } from 'utils/helpers';

const AddOnServices = ({ eventId }) => {
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [isServicesData, setIsServicesData] = useState(false);
  const [addOnServicesData, setAddOnServicesData] = useState([]);
  const dispatch = useDispatch();

  const fetchAddOnServices = async () => {
    const response = await dispatch(
      fetchAddOnServicesData({ event_id: eventId })
    );
    if (response?.status === 200) {
      setAddOnServicesData(response?.data || []);
    }
  };

  useEffect(() => {
    fetchAddOnServices();
  }, [eventId]);

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const {
    // view: viewAccess,
    update: updateAccess,
    delete: deleteAccess,
    create: createAccess,
  } = userDetails?.role_data?.find(
    (item) => item?.permission_name === 'Event Management'
  )?.sub_permission || {};

  const header = useMemo(
    () => [
      { title: 'Categories' },
      { title: 'Free Membership' },
      { title: 'Premium Membership' },
      { title: 'Action' },
    ],
    []
  );

  const ActionButtons = ({ id }) => (
    <div className="center-flex gap-2">
      {deleteAccess === '1' && (
        <Button
          btnStyle="light-outline"
          icon={<img src={icons.deleteIcon} alt="delete" />}
          onClick={() => setSelectedServiceId(id)}
          isSquare
        />
      )}
    </div>
  );

  const rowData = useMemo(
    () =>
      addOnServicesData?.services?.map(
        ({ id, category, free_member, premium_member }) => ({
          data: [
            {
              value: (
                <span className="color-new-car pointer hover-effect">
                  {category}
                </span>
              ),
            },
            { value: <div className="text-nowrap">{free_member}</div> },
            { value: <div className="text-nowrap">{premium_member}</div> },
            { value: <ActionButtons id={id} /> },
          ],
        })
      ),
    [addOnServicesData]
  );

  return (
    <>
      {selectedServiceId && (
        <DeletePopup
          id={selectedServiceId}
          onHide={() => {
            setSelectedServiceId(null);
          }}
          handelSuccess={() => {
            setSelectedServiceId(null);
            fetchAddOnServices();
          }}
          handelDelete={async () => {
            let forData = objectToFormData({ service_id: selectedServiceId });
            const response = await dispatch(deleteOnServicesData(forData));
            return response;
          }}
        />
      )}
      <Card>
        <div className="d-flex justify-content-between align-items-center cmb-14">
          <h2 className="text-16-500-20 cps-24 cpt-24 color-title-navy">
            Add-On Services
          </h2>
          {addOnServicesData?.services && !isServicesData &&(
            <div className="d-flex gap-2 cme-30 cmt-15">
              {createAccess === '1' && (
                <Button
                  text="+ Add Services"
                  btnStyle="primary-outline"
                  className="h-35 text-14-500 w-auto px-3"
                  onClick={() => setIsServicesData(true)}
                />
              )}
              {updateAccess === '1' && (
                <Button
                  icon={<i className="bi bi-pencil-square me-1" />}
                  text="Edit Services"
                  btnStyle="primary-outline"
                  className="h-35 text-14-500 w-auto px-3"
                  onClick={() => {
                    setIsServicesData(true);
                  }}
                />
              )}
            </div>
          )}
        </div>
        <hr />

        {isServicesData ? (
          <div className="cps-20 cpe-20 cpb-20">
            <ServicesDataForm
              setIsServicesData={setIsServicesData}
              eventId={eventId}
              fetchAddOnServices={fetchAddOnServices}
              addOnServicesData={addOnServicesData}
            />
          </div>
        ) : addOnServicesData?.services?.length === 0 ||
          !addOnServicesData?.services ? (
          <div className="d-flex flex-column justify-content-center align-items-center cpb-125">
            <div className="text-center cmt-56">
              <img src={icons.circleInfo} alt="No Data" className="h-60 w-60" />
              <h3 className="cmt-22 text-32-500-40">
                Add-On Services Not Found
              </h3>
              {createAccess === '1' && (
                <div className="cmt-22 d-flex align-items-center justify-content-center">
                  <Button
                    text="+ Add Services"
                    btnStyle="primary-outline"
                    className="h-35 text-14-500 w-auto px-3"
                    onClick={() => setIsServicesData(true)}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="cps-20 cpe-20 cpb-20">
            <Table
              header={header}
              rowData={rowData}
              hidePagination
              customHeaderStyle={{
                backgroundColor: '#2148C0',
                color: 'white',
                height: '45px',
              }}
            />
          </div>
        )}
      </Card>
    </>
  );
};

export default AddOnServices;
